import React, { Fragment, useContext, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { TranslationContext } from "../utils/TranslationProvider";
import { sendResetPassword } from "../actions/security";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Header from "../components/Header";
import { Button, TextField } from "@mui/material";
import { toast } from "react-toastify";

const ForgotPassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const t = useContext(TranslationContext);

  const [state, setState] = useState({
    email: "",
  });

  const onChangeHandler = (event) => {
    const { name, value } = event.target;
    setState((prevUser) => ({
      ...prevUser,
      [name]: value,
    }));
  };

  const onSubmitHandler = (event) => {
    event.preventDefault();
    if (!state.email) {
      toast.error(t("forgotPassword.errors.emailRequired"), {
        theme: "colored",
      });
      return;
    }
    dispatch(sendResetPassword(state, navigate));
  };

  return (
    <Fragment>
      <Header nameClass={"backgorund-color-header"} />
      <div className="login-page-holder">
        <div className="login-page-image">
          <div className="login-page-image-title">
            <h1>{t("forgotPassword.titleLine1")}</h1>
            <h1>{t("forgotPassword.titleLine2")}</h1>
          </div>
        </div>
        <div className="login-content-form">
          <h2>{t("forgotPassword.subtitle")}</h2>
          <form onSubmit={onSubmitHandler}>
            <Row>
              <Col lg={12} className="mb-3">
                <TextField
                  type="email"
                  label={t("forgotPassword.form.emailLabel")}
                  name="email"
                  variant="standard"
                  required
                  value={state.email}
                  onChange={onChangeHandler}
                  className="w-100"
                />
              </Col>
              <Col className="login-button-item">
                <Button type="submit">{t("forgotPassword.form.submit")}</Button>
              </Col>
            </Row>
          </form>
          <div className="registration-section-login-page d-flex justify-content-between align-items-center">
            <div className="registration-button">
              <Link to="/login">{t("forgotPassword.navigation.login")}</Link>
            </div>
            <div className="forgot-passwrod">
              <Link to="/forgot-password-code">
                {t("forgotPassword.navigation.haveCode")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ForgotPassword;
